import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create Earning
export const createEarning = createAsyncThunk(
  'earning/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/earning', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create earning');
    }
  }
);

// Fetch All Earnings
export const fetchEarnings = createAsyncThunk(
  'earning/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/earning');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch earnings');
    }
  }
);

// Fetch Earning by ID
export const fetchEarningById = createAsyncThunk(
  'earning/fetchById',
  async (earningId: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/earning/${earningId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch earning');
    }
  }
);

// Update Earning
export const updateEarning = createAsyncThunk(
  'earning/update',
  async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.put(`/earning/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update earning');
    }
  }
);

// Delete Earning
export const deleteEarning = createAsyncThunk(
  'earning/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/earning/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete earning');
    }
  }
);
